var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaGemeindebus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#3b485e;}.cls-3{fill:#cacaca;}.cls-4{fill:#009bd9;}.cls-5{fill:#eb5c0b;}.cls-6{fill:#f39d6d;}.cls-7{fill:#f3f3f3;}.cls-8{fill:#8b94a3;}.cls-9{fill:#ffe21f;}.cls-10{fill:#ffbd49;}.cls-11{fill:#d8ddeb;}.cls-12{fill:#7a8596;}.cls-13{fill:#59667c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gemeindebus"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.08,137.25V147.5a4.5,4.5,0,0,0,4.5,4.5H49.93a4.51,4.51,0,0,0,4.5-4.5V137.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.89,137.25V147.5a4.51,4.51,0,0,0,4.5,4.5h14.35a4.5,4.5,0,0,0,4.5-4.5V137.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.12,45.25a2.34,2.34,0,0,1-2.34-2.34,3,3,0,0,0-3-3h-2.56a2.34,2.34,0,1,1,0-4.67h2.56a7.67,7.67,0,0,1,7.66,7.66A2.33,2.33,0,0,1,148.12,45.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 142.65,
    y: 42.5,
    width: 9.37,
    height: 25.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.2,45.25a2.34,2.34,0,0,0,2.34-2.34,3,3,0,0,1,3-3h2.56a2.34,2.34,0,1,0,0-4.67H17.53a7.67,7.67,0,0,0-7.66,7.66A2.33,2.33,0,0,0,12.2,45.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.3,
    y: 42.5,
    width: 9.37,
    height: 25.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.33,8H29a9,9,0,0,0-9,9V98H140.33V17A9,9,0,0,0,131.33,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20,127.45v2.48a9,9,0,0,0,9,9H131.33a9,9,0,0,0,9-9v-2.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 19.99,
    y: 114.52,
    width: 120.35,
    height: 12.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 19.99,
    y: 95.06,
    width: 120.35,
    height: 19.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 19.99,
    y: 33.2,
    width: 120.35,
    height: 56.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 19.99,
    y: 89.43,
    width: 120.35,
    height: 5.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 32.96,
    cy: 120.99,
    r: 3.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 41.91,
    cy: 120.99,
    r: 3.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 118.41,
    cy: 120.99,
    r: 3.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 127.36,
    cy: 120.99,
    r: 3.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M127.44,99.9h-8.63a4.89,4.89,0,1,0,0,9.78h8.63a4.89,4.89,0,1,0,0-9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M40.79,99.9H32.17a4.89,4.89,0,1,0,0,9.78h8.62a4.89,4.89,0,1,0,0-9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M114.45,11.93H43.33a8.67,8.67,0,0,0,0,17.34h71.12a8.67,8.67,0,1,0,0-17.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "19.99 89.43 140.33 33.2 140.33 89.43 19.99 89.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 76.95,
    y: 33.2,
    width: 6.43,
    height: 56.24
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaGemeindebus);
export default __webpack_public_path__ + "static/media/ka_gemeindebus.3ad260f1efea7bddd02ee18f2c3e9cff.svg";
export { ForwardRef as ReactComponent };